import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { ThemeService, TitleService } from '@kservice';
import { HttpStatusCode } from '@ktypes/enums';
import { Status } from '@ktypes/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-send-code',
  templateUrl: './send-code.component.html',
  styleUrls: ['./send-code.component.scss'],
})
export class SendCodeComponent implements OnInit, OnDestroy {
  disableSubmitButton = false;
  emailForm: UntypedFormGroup;
  email: UntypedFormControl;
  showEmailVerificationModal = false;

  private _destroy$ = new Subject<void>();
  private _title = 'Send Reset Email';

  constructor(
    private authenticationBloc: AuthenticationBloc,
    private router: Router,
    private titleService: TitleService,
    public themeService: ThemeService
  ) {}

  ngOnInit() {
    this.titleService.set(this._title);
    this.email = new UntypedFormControl(this.email, [Validators.required, Validators.pattern(/^.+@.+$/)]);
    this.emailForm = new UntypedFormGroup({
      email: this.email,
    });

    this.email.setValue(this.authenticationBloc.proposedResetEmail);

    this.authenticationBloc.passwordResetStatus$.pipe(takeUntil(this._destroy$)).subscribe((status) => {
      switch (status.status) {
        case Status.starting:
          this.email.disable();
          this.disableSubmitButton = true;
          break;
        case Status.done:
          this.disableSubmitButton = false;
          return this.router.navigate(['/login/reset/password']);
        case Status.error:
          if (
            status.message?.code === HttpStatusCode.BAD_REQUEST &&
            status.message?.message === 'EmailVerificationRequired'
          ) {
            this.showEmailVerificationModal = true;
            this.email.disable();
          }
          break;
        default:
          this.disableSubmitButton = false;
      }
    });
  }

  ngOnDestroy() {
    this.email = null;
    this._destroy$.next();
    this._destroy$.complete();
  }

  onSubmit() {
    this.authenticationBloc.requestPasswordReset(this.email.value);
  }

  isEmailVerificationModalOpen() {
    this.showEmailVerificationModal = false;
    this.email.enable();
    this.disableSubmitButton = false;
  }
}
